import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CollapseBlock } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField.jsx';
import FormTextEditor from '../../../../antd/form/FormTextEditor/FormTextEditor.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import { url } from '../../../../antd/form/FormValidation.js';

const DepartmentForm = ({ form }) => {
  const { t } = useTranslation();

  const basicInfo = (
    <CollapseBlock
      collapsible
      collapse={true}
      title={t('Informácie o pracovisku (informácie z LDAP)')}
    >
      <FormTextField
        label={t('Názov (slovensky)')}
        name={'title_sk'}
        disabled
      />

      <FormTextField label={t('Názov (anglicky)')} name={'title_sk'} disabled />

      <FormTextField label={t('Telefón')} name={'phone'} disabled />

      <FormTextField
        label={t('Web stránka')}
        name={'website'}
        rules={[url(t)]}
        disabled
      />
    </CollapseBlock>
  );

  const contentSK = (
    <CollapseBlock collapsible collapse={true} title={t('Slovenská verzia')}>
      <FormTextEditor
        label={t('Popis')}
        name={'description_sk'}
        imgUploadDirectory={'departments'}
        fileUploadDirectory={'departments'}
      />

      <FormTextEditor
        label={t('Aktivity')}
        name={'activities_sk'}
        imgUploadDirectory={'departments'}
        fileUploadDirectory={'departments'}
      />
    </CollapseBlock>
  );

  const contentEN = (
    <CollapseBlock collapsible collapse={false} title={t('Anglická verzia')}>
      <FormTextEditor
        label={t('Popis')}
        name={'description_en'}
        imgUploadDirectory={'departments'}
        fileUploadDirectory={'departments'}
      />
      <FormTextEditor
        label={t('Aktivity')}
        name={'activities_en'}
        imgUploadDirectory={'departments'}
        fileUploadDirectory={'departments'}
      />
    </CollapseBlock>
  );

  return (
    <>
      {basicInfo}
      {contentSK}
      {contentEN}

      <FormButtonsContainer>
        <FormButton submitOnClick={true} submitKey={'departments'}>
          {t('Uložiť')}
        </FormButton>
      </FormButtonsContainer>
    </>
  );
};

DepartmentForm.propTypes = {
  form: PropTypes.any,
};

export default DepartmentForm;
